import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { getHttpHeaders } from '@commons/utility/util';
import { environment } from '@environments/environment';

import { routes } from '@model/constants/routes';
import { VerifyLoanNovationType } from '@model/home-loan/home-loan-models';

@Injectable({
  providedIn: 'root',
})
export class HomeLoanService {
  private readonly apiBackDebtUrl: string;
  private readonly headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    this.apiBackDebtUrl = environment.apiBackDebtUrl;
    this.headers = getHttpHeaders();
  }

  public validateExtendTermLoans(loansIds: string[]): Observable<Array<VerifyLoanNovationType>> {
    return this.http.post<Array<VerifyLoanNovationType>>(
      `${this.apiBackDebtUrl}${routes.verifyLoanNovation}`,
      { loanCodes: loansIds },
      { headers: this.headers }
    );
  }
}
